/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  /**
   * Cart recommendations carousel ("Recommended for you")
   *
   * Fills snippets/cart-recommended-products.liquid with products and (re)starts the carousel.
   *
   * Complementary products cannot be read from Liquid — the reserved
   * shopify--discovery--product_recommendation namespace is only reachable through the Product
   * Recommendations API. So we fetch sections/cart-recommendations here:
   *   1. intent=complementary — curated add-ons, needs setup in the Search & Discovery app
   *   2. intent=related       — auto-generated by Shopify, so this always returns something
   * A server-rendered fallback collection, when configured, is left alone unless the API has
   * something better to show.
   */
  var BLOCK = '[data-cart-recs]';
  var CONTENT = '[data-cart-recs-content]';
  var SLIDER = '[data-pair-products]';
  var CELL = '[data-upsell-holder]';

  function startSlider(block) {
    if (typeof window.Flickity === 'undefined') return;

    var slider = block.querySelector(SLIDER);
    if (!slider) return;

    if (slider.classList.contains('flickity-enabled')) {
      var existing = window.Flickity.data(slider);
      if (existing) {
        existing.reloadCells();
        existing.resize();
      }
      return;
    }

    if (slider.querySelectorAll(CELL).length < 2) return;

    // Options mirror CartDrawer.renderPairProducts() in theme.dev.js so both paths look identical
    new window.Flickity(slider, {
      wrapAround: true,
      pageDots: true,
      adaptiveHeight: true,
      prevNextButtons: false,
      on: {
        ready: function () {
          this.reloadCells();
          requestAnimationFrame(this.resize.bind(this));
        },
      },
    });
  }

  function fetchIntent(baseUrl, intent) {
    return fetch(baseUrl + '&intent=' + intent)
      .then(function (response) {
        return response.ok ? response.text() : '';
      })
      .then(function (text) {
        if (!text) return '';
        var parsed = document.createElement('div');
        parsed.innerHTML = text;
        var content = parsed.querySelector(CONTENT);
        return content && content.innerHTML.trim().length ? content.innerHTML : '';
      })
      .catch(function () {
        return '';
      });
  }

  function load(block) {
    if (block.dataset.cartRecsLoaded) return;
    block.dataset.cartRecsLoaded = 'true';

    var baseUrl = block.dataset.recommendationsUrl;

    if (!baseUrl) {
      startSlider(block);
      return;
    }

    // Show the server-rendered fallback right away rather than waiting on the network
    if (block.hasAttribute('data-has-fallback')) startSlider(block);

    fetchIntent(baseUrl, 'complementary')
      .then(function (markup) {
        return markup || fetchIntent(baseUrl, 'related');
      })
      .then(function (markup) {
        if (markup) block.innerHTML = markup;
        startSlider(block);
      });
  }

  function scan() {
    document.querySelectorAll(BLOCK).forEach(load);
  }

  // Coalesce bursts of mutations into one scan per frame
  var scanQueued = false;
  function queueScan() {
    if (scanQueued) return;
    scanQueued = true;
    requestAnimationFrame(function () {
      scanQueued = false;
      scan();
    });
  }

  // The cart drawer is rendered from a <template> on first open and replaced on every cart
  // update, so watch for the block appearing rather than binding once on load.
  new MutationObserver(queueScan).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
